import { render, staticRenderFns } from "./CargaPetroleo.vue?vue&type=template&id=0dd723c0&"
import script from "./CargaPetroleo.vue?vue&type=script&lang=js&"
export * from "./CargaPetroleo.vue?vue&type=script&lang=js&"
import style0 from "./CargaPetroleo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports